// extracted by mini-css-extract-plugin
export var carrierIcon = "_tp-0";
export var carrierLogo = "_tp-1";
export var detailsSection = "_tp-2";